
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M990 190.5c0 28.5-23.1 51.6-51.6 51.6H61.6C33.1 242.1 10 219 10 190.5s23.1-51.6 51.6-51.6h876.8c28.5 0 51.6 23.1 51.6 51.6zM990 500c0 28.5-23.1 51.6-51.6 51.6H61.6C33.1 551.6 10 528.5 10 500s23.1-51.6 51.6-51.6h876.8c28.5 0 51.6 23.1 51.6 51.6zM990 809.5c0 28.5-23.1 51.6-51.6 51.6H61.6C33.1 861.1 10 838 10 809.5s23.1-51.6 51.6-51.6h876.8c28.5 0 51.6 23.1 51.6 51.6z"}})])
          )
        }
      }
    